import Vue from 'vue'
import VueRouter, { RouterOptions } from 'vue-router'

import routes from './routes/index'
import store from './store'

Vue.use(VueRouter)

const router = new VueRouter({
  routes,
  mode: 'history',
  base: '/',
} as RouterOptions)

router.beforeEach((to, _from, next) => {
  // 路由跳转关闭全局错误遮罩层，并打开loading动画
  store.dispatch('error/close')
  store.dispatch('loading/show')

  document.title = `${to.meta.title} - 校宝收银宝` || '校宝收银宝' // template.name

  next()
})

router.afterEach(() => {
  store.dispatch('loading/close')
})

export default router
